import Vue from 'vue'
import i18n from '@/libs/i18n'

const defaultLang = 'uz'

const errSwalFun = (view, error, option = {}) => {
  let errorMessage = view.$t('Unknown')
  let errorTitle = view.$t(option.title ?? 'Error')
  const errors = error?.response?.data
  if (errors) {
    if (typeof errors === 'string') {
      errorMessage = errors
    } else if (errors.message) {
      errorMessage = errors.message
      if (errors.source === 'OAK') {
        errorTitle = 'OAK xatoligi'
        if (errors.oak_status_code) {
          errorMessage += ` (HTTP ${errors.oak_status_code})`
        }
      }
    } else {
      errorMessage = ''
      // eslint-disable-next-line no-restricted-syntax,guard-for-in
      for (const key in errors) {
        errorMessage += `${key} - ${errors[key]}\n`
      }
    }
  }
  view.$bvToast.toast(errorMessage, {
    variant: option.variant ?? 'danger',
    solid: option.solid ?? true,
    title: errorTitle,
  })
}
Vue.prototype.$langName = value => (value ? (value[i18n.locale] ?? value[defaultLang] ?? '') : '')

Vue.prototype.$removeSwal = (view, data, url, callback, options = {}) => {
  view.$swal({
    title: view.$t(options.title ?? 'Are you sure?'),
    text: view.$t(options.text ?? "You won't be able to revert this!"),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: view.$t(options.confirmButtonText ?? 'Yes, delete it!'),
    cancelButtonText: view.$t(options.cancelButtonText ?? 'Cancel'),
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-outline-danger ml-1',
    },
    buttonsStyling: false,
  }).then(result => {
    if (result.value) {
      view.$store.dispatch(url, data).then(res => {
        callback(res)
        view.$swal({
          icon: 'success',
          title: view.$t(options.successTitle ?? 'Delete!'),
          text: view.$t(options.successText ?? 'Your file has been deleted.'),
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
      }).catch(err => {
        const responseData = err?.response?.data
        const backendMessage = typeof responseData?.message === 'string'
          ? responseData.message
          : null
        view.$swal({
          icon: 'error',
          title: responseData?.source === 'OAK'
            ? 'OAK ma’lumotlari topilmadi'
            : view.$t(options.errorTitle ?? 'Error!'),
          text: backendMessage ?? view.$t(options.errorText ?? 'Your file has not been deleted.'),
          customClass: {
            confirmButton: 'btn btn-danger',
          },
        })
        if (!backendMessage) errSwalFun(view, err)
      })
    }
  })
}

Vue.prototype.$createSwal = (view, data, url, callback, errorBack = (() => {})) => {
  view.$store.dispatch(url, data).then(res => {
    view.$bvToast.toast(view.$t('Successfully completed'), {
      variant: 'success',
      solid: true,
      title: view.$t('Success'),
    })
    callback(res)
  }).catch(err => {
    errSwalFun(view, err)
    errorBack()
  })
}
Vue.prototype.$errorSwal = errSwalFun

Vue.prototype.$oldSiteUrl = 'http://old-phd.mininnovation.uz'

Vue.prototype.$technicalAdminLink = 'https://t.me/ilmiy_darajali_kadrlar'

Vue.prototype.MAX_LIMIT = 9999
